import React from 'react'
import styled from '@emotion/styled'

import { fontSizeSmall, fontWeightSemibold } from '../../constants/principles'

const KbbIcoSvg = __PATH_PREFIX__ + '/Landing/KBBICO-Logo-rgb.svg'

export default () => (
  <HeightDiv>
    <StyledImgDiv>
      <StyledImg itemProp="image" src={KbbIcoSvg} alt="KBB.com Instant Cash Offer" />
    </StyledImgDiv>
    <StyledTextDiv>This subscriber no longer participates in the Kelley Blue Book&reg; Instant Cash Offer program. </StyledTextDiv>
  </HeightDiv>
)

const StyledImgDiv = styled.div`
  width: 250px;
  display: flex;
  padding-bottom: 64px;
`
const StyledImg = styled.img`
  width: 250px;
`
const StyledTextDiv = styled.div`
  font-size: ${fontSizeSmall};
  text-align: center;
  font-weight: ${fontWeightSemibold};
`

const HeightDiv = styled.div`
  padding-top: 32px;
  min-height: 75vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
`
